import { useQuery } from '@tanstack/react-query';
import { useParams } from '@/providers/RouterShim';

import type { RequestStateQuery } from '../../@types/RequestStateQuery';
import type { Site } from '../../@types/SiteModel';
import { getJSON, type RequestError } from '../../fetch';
import useAuth from '../../hooks/useAuth';
import usePermissionWebsite from '../permissions/usePermissionWebsite';

export const SITE_QUERY = 'CMS_SERVICE_URI/sites/:branchId';

const useSite = (): [Site | undefined, RequestStateQuery] => {
  const { branchId } = useParams();
  const { getToken } = useAuth();
  const [permission] = usePermissionWebsite();

  const { data, isLoading, isSuccess, isError, error } = useQuery<Site | null, RequestError>({
    queryKey: [SITE_QUERY, branchId],
    queryFn: async () => {
      try {
        return await getJSON<Site | null>(
          `${process.env.NEXT_PUBLIC_CMS_SERVICE_URI}/sites/${branchId}`,
          getToken()!,
        );
      } catch (e) {
        const error = e as RequestError;
        if (error.statusCode && error.statusCode === 404) {
          return null;
        }
        throw e;
      }
    },
    enabled: !!permission?.enabled && !!branchId,
  });

  return [data || undefined, { isLoading, isSuccess, isError, error: error || undefined }];
};

export default useSite;
